import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import { autosDecode } from '../data/mockData';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

export default function Home() {
  const [active, setActive] = useState(null);

  return (
    <div className="min-h-screen pt-28 relative overflow-hidden flex flex-col items-center justify-center">
      <div className="absolute inset-0 z-0 opacity-30 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-cyan-600/10 rounded-full blur-[120px]" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-amber-500/10 rounded-full blur-[120px]" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full grid-bg mt-[30vh]" />
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-zinc-900/50 border border-zinc-700/50 text-zinc-400 text-[10px] tracking-widest uppercase mb-8 backdrop-blur-sm"
        >
          <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 pulse-dot" />
          Data Utility Infrastructure // System Online
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="text-5xl md:text-7xl lg:text-8xl font-black uppercase tracking-tighter mb-6"
        >
          <span className="text-transparent bg-clip-text bg-gradient-to-br from-zinc-100 to-zinc-600">Build Your</span> <br />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-amber-400 text-glow-cyan">
            Sovereign Node
          </span>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="text-base md:text-lg text-zinc-400 max-w-2xl mx-auto mb-4 tracking-wide"
        >
          Configure, mint, and deploy your custom BSM-C vehicle to the enterprise data highway. <br className="hidden md:block" />
          Real digital income. Zero speculation. Backed by corporate data asset value.
        </motion.p>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
          className="text-xs text-amber-400 font-mono mb-12"
        >
          Target Floor: <span className="text-glow-amber font-bold">$1,000/Month</span> per active node
        </motion.p>

        {/* AUTOS Decode */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.5 }}
          className="flex items-center justify-center gap-3 md:gap-4 mb-6 flex-wrap"
        >
          {autosDecode.map((item, i) => (
            <button
              key={i}
              onMouseEnter={() => setActive(i)}
              onMouseLeave={() => setActive(null)}
              className={`relative px-5 py-4 md:px-6 md:py-5 bg-zinc-900/60 border backdrop-blur-sm transition-all duration-300 hover:-translate-y-1 ${
                active === i ? 'border-cyan-400 box-glow-cyan' : 'border-zinc-800 hover:border-zinc-700'
              }`}
            >
              <span className="block text-2xl md:text-3xl font-black text-cyan-400">{item.letter}</span>
              <span className="block text-[9px] md:text-[10px] text-zinc-500 uppercase tracking-widest mt-1">{item.word}</span>
            </button>
          ))}
        </motion.div>

        <AnimatePresence mode="wait">
          {active !== null && (
            <motion.div
              key={active}
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0 }}
              className="text-sm text-amber-400 italic mb-8 h-5"
            >
              "{autosDecode[active].desc}"
            </motion.div>
          )}
          {active === null && <div className="h-5 mb-8" />}
        </AnimatePresence>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.7 }}
          className="flex flex-col sm:flex-row items-center justify-center gap-4"
        >
          <Link
            to="/showroom"
            className="group relative px-8 py-4 bg-cyan-500 text-zinc-950 font-bold uppercase tracking-widest text-sm overflow-hidden rounded flex items-center gap-3 hover:box-glow-cyan transition-all"
          >
            <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300" />
            <span className="relative z-10 flex items-center gap-2">
              Node Configurator <SafeIcon icon={FiIcons.FiArrowRight} />
            </span>
          </Link>
          <Link
            to="/gateway"
            className="px-8 py-4 bg-amber-500/10 border border-amber-500/50 text-amber-400 font-bold uppercase tracking-widest text-sm rounded hover:bg-amber-500/20 hover:box-glow-amber transition-all flex items-center gap-3"
          >
            <SafeIcon icon={FiIcons.FiServer} />
            Corporate Gateway
          </Link>
        </motion.div>
      </div>
    </div>
  );
}